module.exports = __webpack_public_path__ + "img/valuationgood.7af2bc2e.png";